class ImageSlideshow {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.slideshow-slide'));
    this.dots = Array.from(container.querySelectorAll('.slideshow-dot'));

    this.autoplay = container.dataset.autoplay === 'true';
    this.speed = parseInt(container.dataset.speed, 10) || 5000;
    this.current = 0;
    this.timer = null;

    // expose the duration to CSS so the dot fill animation matches the timer
    container.style.setProperty('--slide-duration', `${this.speed}ms`);

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index, true));
    });

    // pause on hover / focus, resume on leave
    container.addEventListener('mouseenter', () => this.stop());
    container.addEventListener('mouseleave', () => { if (this.autoplay) this.play(); });

    if (this.slides.length > 1) {
      this.goTo(0, false);
      if (this.autoplay) this.play();
    }
  }

  goTo(index, userTriggered) {
    if (!this.slides.length) return;
    const total = this.slides.length;
    const next = (index + total) % total;

    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active', 'is-playing');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'false');

    this.current = next;

    this.slides[this.current].classList.add('is-active');
    const dot = this.dots[this.current];
    if (dot) {
      dot.classList.add('is-active');
      dot.setAttribute('aria-selected', 'true');
      // keep the dot "playing" (animating) across every auto-advance,
      // not just the very first slide
      if (this.timer) {
        dot.classList.add('is-playing');
      }
      // restart the fill animation
      const fill = dot.querySelector('.slideshow-dot__fill');
      if (fill) {
        fill.style.animation = 'none';
        // force reflow so the animation restarts cleanly
        void fill.offsetWidth;
        fill.style.animation = '';
      }
    }

    if (userTriggered && this.autoplay) {
      this.stop();
      this.play();
    } else if (userTriggered) {
      this.stop();
    }
  }

  play() {
    if (this.slides.length < 2) return;
    this.stop();
    const dot = this.dots[this.current];
    if (dot) dot.classList.add('is-playing');
    this.timer = setInterval(() => this.goTo(this.current + 1, false), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.dots.forEach((dot) => dot.classList.remove('is-playing'));
  }
}

function initSlideshows() {
  document.querySelectorAll('.slideshow-section').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new ImageSlideshow(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initSlideshows);
document.addEventListener('shopify:section:load', initSlideshows);
